// extracted by mini-css-extract-plugin
module.exports = {"analyticsIcon":"AnalyticsWidget_analyticsIcon__2IDXs","content":"AnalyticsWidget_content__28St_"};